import { Response } from 'api/typegen/client/get';
import { useGetClientConstraints, useGetConstraints } from 'api';
import isAuthenticated from 'utils/isAuthenticated';
import useClient from './useClient';

type Props = {
  clientResponse?: Response | undefined;
};

export const useConstraints = () => {
  const isLogged = isAuthenticated();
  const { client } = useClient();
  const apiConstraints = useGetConstraints();
  const apiClientConstraints = useGetClientConstraints();

  const getConstraintsApi = ({ clientResponse }: Props) => {
    const isLoggedAndAgeDefined = isLogged && (clientResponse || client)?.age;
    if (isLoggedAndAgeDefined) return apiClientConstraints;
    return apiConstraints;
  };

  return { getConstraintsApi };
};
